<div class="max-w-1xl mx-auto bg-white p-8 rounded-lg shadow-lg">
  <h2 class="text-xl font-semibold mb-4">Lyfis Partner Profiles</h2>
  <div class="flex justify-end items-center w-full mb-3">
    <div nz-row nzjusty nzJustify="end" nzAlign="middle">
      <button [routerLink]="['/lyfis/create']" nz-button nzType="primary">
        Create Partner Profile
      </button>
    </div>
  </div>
<nz-table
[nzData]="data"
[nzLoading]="tableLoading"
[nzFrontPagination]="false"
[nzPageIndex]="page"
[nzPageSize]="pageSize"
[nzTotal]="totalRecords"
(nzPageIndexChange)="onPageIndexChange($event)"
(nzPageSizeChange)="onPageSizeChange($event)"
>
<thead>
  <tr>
    <th>
      Partner
      <nz-filter-trigger [nzActive]="selectedPartnerIds.length>0" [nzDropdownMenu]="partnerTypeMenu">
        <span nz-icon nzType="filter"></span>
      </nz-filter-trigger>
    </th>
    <th>
      Active
      <nz-switch [ngModel]="activeFilter" (ngModelChange)="onActiveToggle($event)" [nzCheckedChildren]="'true'" [nzUnCheckedChildren]="'false'" style="margin-left: 8px;"></nz-switch>
    </th>
    <th>Question Blocks</th>
    <th>Enabled Diseases</th>
    <th>Updated At</th>
    <th>Action</th>
  </tr>
</thead>
<tbody>
  <tr *ngFor="let r of data">
    <td>{{ getPartnerLabel(r.partnerId) }}</td>
    <td>
      <nz-tag [nzColor]="r.active ? 'green' : 'red'">{{ r.active ? 'Active' : 'Inactive' }}</nz-tag>
    </td>
    <td>{{ r.questionBlockIds.length || 0 }}</td>
    <td>{{ getEnabledDiseasesLabel(r.enabledDiseases) }}</td>
    <td>{{ r.lastModifiedAt || r.createdAt | date: 'medium' }}</td>
    <td>
      <button nz-button nzType="primary" nzSize="small" (click)="onEdit(r._id!)">View</button>
    </td>
  </tr>
</tbody>
</nz-table>

<nz-dropdown-menu #partnerTypeMenu="nzDropdownMenu">
  <div class="bg-white shadow-lg rounded-md  p-3" style="max-height: 500px; display: flex; flex-direction: column;">
    <div class="mb-2 flex items-center justify-between">
      <span class="font-semibold text-gray-700">Filter by Partner</span>
    </div>
    <nz-divider class="my-2"></nz-divider>
    <div class="pr-1 overflow-auto h-[300px]"  >
      <nz-checkbox-wrapper (nzOnChange)="onPartnerTempChange($event)">
        <div *ngFor="let opt of partnerOptions" class="py-1">
          <label nz-checkbox [nzValue]="opt.value" [ngModel]="partnerTempSelected.includes(opt.value)">
            <span class="text-sm text-gray-700 whitespace-nowrap">{{ opt.label }}</span>
          </label>
        </div>
      </nz-checkbox-wrapper>
    </div>
    <nz-divider class="my-2"></nz-divider>
    <div class="flex justify-end gap-2">
      <button nz-button nzType="default" (click)="resetPartnerFilter()">Reset</button>
      <button nz-button nzType="primary" (click)="applyPartnerFilter()">Ok</button>
    </div>
  </div>
</nz-dropdown-menu>
</div>

